<template>

  <div class="p-3">
    <div class="row">
      <div class="col-sm">
        <div
          v-for="groupNumber in 28"
          class="card mb-2">
          <div class="card-header">Question: {{ groupNumber }}</div>
          <div>
            <table border=1>
              <tr
                v-for="(personality, personality_index) in getGroupItems(groupNumber)">
                <td width="100">{{ personality['term'] }}</td>
                <td width="100">
                  <label>
                    <input
                      type="radio"
                      :name="`${groupNumber}-${personality_index}`"
                      :value="'most'"
                      @change="setItem(groupNumber, 'most', personality['term'])"
                      v-model="values[personality['term']]"> {{ personality['most']  }} (most)
                  </label>
                </td>
                <td width="100">
                  <label>
                    <input
                      type="radio"
                      :name="`${groupNumber}-${personality_index}`"
                      :value="'least'"
                      @change="setItem(groupNumber, 'least', personality['term'])"
                      v-model="values[personality['term']]"> {{ personality['least'] }} (least)
                  </label>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div
        class="col-sm"
        v-if="meta">
        <div class="card mb-3">
          <div class="card-header">
            Change
          </div>
          <div class="card-body">
            <highcharts
              :options="chartOptions">
              </highcharts>
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-header">
            Prioridades
          </div>
          <div class="card-body">
            <highcharts
              :options="chartOptions2">
              </highcharts>
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-header">
            Category
          </div>
          <div class="card-body">
            {{ meta.patternKey }}
          </div>
        </div>
        <div
          v-if="meta.patternInfo"
          class="card mb-3">
          <div class="card-header">
            Type
          </div>
          <table
            class="table table-bordered">
            <!-- <tr>
              <td>Emoções:</td>
              <td>{{ meta.classicInfo.emotions }}</td>
            </tr> -->
            <tr>
              <td>Nome:</td>
              <td>{{ meta.patternInfo.name }}</td>
            </tr>
            <tr>
              <td>Objetivo:</td>
              <td>{{ meta.patternInfo.goal }}</td>
            </tr>
            <tr>
              <td>Julga os outros por:</td>
              <td>{{ meta.patternInfo.judges_others }}</td>
            </tr>
            <tr>
              <td>Influencia os outros por:</td>
              <td>{{ meta.patternInfo.influences_others }}</td>
            </tr>
            <tr>
              <td>Valor para a organização:</td>
              <td>{{ meta.patternInfo.value_organization }}</td>
            </tr>
            <tr>
              <td>Uso excessivo:</td>
              <td>{{ meta.patternInfo.overuses }}</td>
            </tr>
            <tr>
              <td>Sob pressão:</td>
              <td>{{ meta.patternInfo.under_pressure }}</td>
            </tr>
            <tr>
              <td>Medos:</td>
              <td>{{ meta.patternInfo.fears }}</td>
            </tr>
            <tr>
              <td>Aumentaria a eficácia com mais:</td>
              <td>{{ meta.patternInfo.increase_effectiveness }}</td>
            </tr>
            <tr>
              <td>Descrição</td>
              <td><div v-html="meta.patternInfo.description.replace(/\n/g, '<br>')"></div></td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-body">
        <div>
          <pre>{{ meta }}</pre>
        </div>
        <div>
          <pre>{{ values }}</pre>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
/*
Descriptions
https://www.discprofiles4u.com/blog/2012/disc-profile-test-15-classical-patterns-1-of-20/
*/
import Highcharts from 'highcharts'
import {Chart} from 'highcharts-vue'
import HighchartsMore from 'highcharts/highcharts-more'
import DiscSource from './DiscSource'
import DiscResult from './DiscResult'
HighchartsMore(Highcharts)

export default {
  name: 'Disc',
  components: {
    highcharts: Chart
  },
  data () {
    return {
      values: {
        'Expressivo': 'least',
        'Difícil de agradar': 'most',
        'Obediente': 'least',
        'Colaborativo': 'least',
        'Fechado': 'most',
        'Atencioso': 'least',
        'Sistemático': 'most',
        'Cooperativo': 'least',
        'Prestativo': 'most',
        'Amigável': 'least',
        'Receoso': 'most',
        'Amável': 'least',
        'Simpático': 'most',
        'Cuidadoso': 'most',
        'Próximo': 'least',
        'Afável': 'most',
        'Paciente': 'least',
        'Tímido': 'least',
        'Perspicaz': 'most',
        'Moderado': 'least',
        'Equilibrado': 'least',
        'Controlado': 'least',
        'Agradável': 'most',
        'Generoso': 'least',
        'Minucioso': 'most',
        'Maleável': 'least',
        'Modesto': 'least',
        'Refinado': 'most',
        'Previsível': 'least',
        'Leal': 'least',
        'Cauteloso': 'most',
        'Ousado': 'least',
        'Obstinado': 'least',
        'Exato': 'most',
        'Inspirador': 'most',
        'Original': 'least',
        'Cativante': 'least',
        'Inovador': 'most',
        'Confiante': 'least',
        'Persuasivo': 'most',
        'Convincente': 'least',
        'Corajoso': 'most',
        'Encantador': 'most',
        'Vigoroso': 'least',
        'Preparado': 'most',
        'Contundente': 'most',
        'Alto Astral': 'least',
        'Persistente': 'most',
        'Insistente': 'least',
        'Estimulante': 'most',
        'Independente': 'least',
        'Conversador': 'most',
        'Jovial': 'most',
        'Diplomático': 'most',
        'Consciencioso': 'most',
        'Realizado': 'most'
      },
      personalities: DiscSource.personalities
    }
  },
  computed: {
    meta () {
      return DiscResult.get(this.values)
    },
    isFilled () {
      return Object.values(this.values).length === 56
    },
    chartOptions () {
      return {
        chart: {
          zoomType: 'lines'
        },
        title: {
          text: 'Graph III'
        },
        subtitle: {
          text: null
        },
        xAxis: {
          categories: ['D', 'I', 'S', 'C']
        },
        yAxis: { // Secondary yAxis
          gridLineWidth: 0,
          title: {
            text: 'Intensidade'
          },
          minorTickInterval: 4,
          minorTickLength: 0,
          minorTickWidth: 1,
          minorGridLineColor: '#000000',
          min: 0,
          max: 28,
          startOnTick: true,
          endOnTick: false,
          plotBands: [{ // mark the weekend
            color: '#FFFFFF',
            from: 0,
            to: 4,
            label: {
              text: '1',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 4,
            to: 8,
            label: {
              text: '2',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 8,
            to: 12,
            label: {
              text: '3',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FCFFC5',
            from: 12,
            to: 16,
            label: {
              text: '4',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 16,
            to: 20,
            label: {
              text: '5',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 20,
            to: 24,
            label: {
              text: '6',
              align: 'right',
              x: -10
            }
          }, { // mark the weekend
            color: '#FFFFFF',
            from: 24,
            to: 28,
            label: {
              text: '7',
              align: 'right',
              x: -10
            }
          }]
        },
        tooltip: {
          shared: true
        },
        series: [{
          name: null,
          data: this.meta.changeIntensities // [20, 11, 8, 18]
        }]
      }
    },
    chartOptions2 () {
      return {
        chart: {
          polar: true
        },
        title: {
          text: 'Highcharts Polar Chart'
        },
        subtitle: {
          text: null
        },
        pane: {
          startAngle: -66.66,
          endAngle: (360 - 66.66)
        },
        xAxis: {
          categories: [
            'Resultados', // D
            'Ação', // DI/ID
            'Entusiasmo', // I
            'Colaboração', // IS/SI
            'Apoio', // S
            'Estabilidade', // CS/SC
            'Precisão', // C
            'Desafio' // CD/DC
          ],
          tickmarkPlacement: 'on'
        },
        yAxis: {
          min: 0
        },
        series: [{
          type: 'area',
          name: 'Area',
          data: this.meta.circlePercents
        }/* , {
          type: 'line',
          name: 'Line',
          data: [1, 8, 2, 7, 3, 6, 4, 5]
        } */]
      }
    }
  },
  created () {
  },
  methods: {
    getGroupItems (n) {
      return this.personalities.filter(item => item.groupNumber === n)
    },
    setItem (groupNumber, type, term) {
      this.personalities
      .filter(item => item.groupNumber === groupNumber && item.term !== term)
      .map(item => {
        if (this.values[item.term] === type) {
          this.values[item.term] = undefined
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Disc/Disc.vue